export default __webpack_public_path__ + "static/media/244.560f6545.jpg";